import bankData from "@constant/bank.json";
import { normalizeTaiwanCharacter } from "@utils/common";

import React, { useEffect, useState } from "react";
import { Select } from "antd";

type Props = {
  bankCode?: string;
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
};

type BankBranchOption = {
  value: string;
  label: string;
  branchCode: string;
};

const BankBranchList = (props: Props) => {
  const { value, onChange, bankCode, disabled } = props;
  const [bankBranchList, setBankBranchList] = useState<{ bankBranchName: string; branchCode: string }[]>();

  const bankBranchOptions: BankBranchOption[] | undefined = bankBranchList?.map(
    (info: { branchCode: string; bankBranchName: string }) => ({
      value: info.bankBranchName,
      label: info.bankBranchName,
      branchCode: info.branchCode,
    }),
  );

  useEffect(() => {
    const banches = bankData
      .filter((item) => item.bankCode === bankCode)
      .map((item) => ({
        bankBranchName: item.bankName,
        branchCode: item.branchCode,
      }));
    setBankBranchList(banches);
  }, [bankCode]);

  return (
    <Select
      value={value || undefined}
      showSearch
      onChange={(inputValue) => onChange?.(inputValue)}
      style={{ width: "100%" }}
      filterOption={(input, option?: BankBranchOption) => {
        if (!option) return false;
        const keyword = normalizeTaiwanCharacter(input.toLowerCase());
        return (
          normalizeTaiwanCharacter(option.label.toLowerCase()).includes(keyword) ||
          option.branchCode.includes(keyword)
        );
      }}
      placeholder="請選擇"
      options={bankBranchOptions}
      disabled={disabled}
    />
  );
};

export default BankBranchList;
